<div class="dashboard-container">
  <div class="nav-container" col="12">
      <div class="d-flex align-items-start">
          <br>
          
          <ul class="nav nav-pills nav-fill" id="v-pills-tab" role="tablist">
              <br>
              <button  class="nav-link myBtn"  *ngFor="let item of utility.reportsSanral" (click)="onReportSelectionChange(item.reportId)">{{item.name}}</button>
              <button class="bi bi-printer print" (click)="printReport()"></button>
              <br>
              <!-- <button class="nav-link myBtn" (click)="printReport()">Print Report</button> -->

          </ul>
      </div>
  </div>
  <div class="report-container">
      <powerbi-report
          [embedConfig]="reportConfig"
          [cssClassName]="reportClass"
          [phasedEmbedding]="phasedEmbeddingFlag"
          [eventHandlers]="eventHandlersMap"
      >
      </powerbi-report>

      <div *ngIf="!isEmbedded" class="display-message">
          <label>{{ displayMessage }}</label>
      </div>
  </div>
</div>
